import React from "react";
import { FinanceProvider } from "./context/FinanceContext";
import StatCards from "./components/StatCards";
import ChartPanel from "./components/ChartPanel";
import ActionPanel from "./components/ActionPanel";
import "./App.css";

export default function App() {
  return (
    <FinanceProvider>
      <div className="app">
        {/* Top 5 stat cards */}
        <section className="section-cards">
          <StatCards />
        </section>

      

        {/* Bottom split: left = actions, right = chart */}
        <section className="section-split">
          <div className="split-left">
            <ActionPanel />
          </div>
          <div className="split-right">
            <ChartPanel />
          </div>
        </section>
      </div>
    </FinanceProvider>
  );
}
